var app;

app = window.App || (window.App = {});

app.CostAccountingNoteCopier = (function() {
  function CostAccountingNoteCopier() {}

  CostAccountingNoteCopier.prototype.copy = function() {
    var source, target;
    target = $('#cost_accounting_record_aufteilung_kontengruppen')[0];
    source = $('#vorheriger-kommentar')[0];
    return target.value = source.innerHTML.trim();
  };

  CostAccountingNoteCopier.prototype.bind = function() {
    var container, self;
    self = this;
    container = '#cost_accounting_note_copy';
    $(document).on('click', container + " a", function(e) {
      e.preventDefault();
      return self.copy();
    });
    return $(container).removeClass('hidden');
  };

  return CostAccountingNoteCopier;

})();
